import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am <span className="purple">SNEHIT RODA </span>
            <br />
            With a Masters degree in Applied Computer Science from Dalhousie University,
            I carry over 5 years of hands-on experience as a Software Developer in building scalable backend services in a distrubted environment. 
            <br />
            </p>
          <ul>
            
            <li className="about-activity">
              <ImPointRight /> Java, Spring Boot, Python, Microservices, RESTful APIs
            </li>
            <li className="about-activity">
              <ImPointRight /> AWS, Lambda, Docker, Redis, MySQL, MongoDB, Jenkins, Git
            </li>
            <li className="about-activity">
              <ImPointRight /> Agile, Scrum, JIRA
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Intelligence is the ability to adapt to change!"{" "}
          </p>
          <footer className="blockquote-footer">Stephen Hawking</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
